import { createSlice } from "@reduxjs/toolkit";

const defaultWheelSettings = {
		spinStarted: false,
		wheelDuration: 10,
		wheelSpinMode: 1,
		supergameEnabled: false,
		supergameCostThreshold: 300,
		supergameCreated: false,
		supergameStarted: false,
		supergameFinished: false,
		wheelTheme: 'neon',
		showChances: false,
		wheelSize: 768,
		wheelSoundVolume: 0.2,
		emote: undefined,
		randomSpinDuration: false,
		wheelDurationMin: 5,
		wheelDurationMax: 15,
		autoSpin: false,
};

const loadWheelSettings = () => {
	try {
		const savedSettings = JSON.parse(localStorage.getItem('wheel-settings-v2'));
		if (!savedSettings || typeof savedSettings !== 'object') {
			return defaultWheelSettings;
		}

		const settings = { ...savedSettings };
		delete settings.wheelSound;
		delete settings.wheelSounds;
		return {
			...defaultWheelSettings,
			...settings,
		};
	} catch {
		return defaultWheelSettings;
	}
}

export const wheelSettingsSlice = createSlice({
	name: "wheelSettings",
	initialState: loadWheelSettings(),
	reducers: {
		setSpinStarted: (state, action) => {
			const spinStarted = action.payload;
			state.spinStarted = spinStarted;
		},
		setWheelDuration: (state, action) => {
			const wheelDuration = action.payload;
			state.wheelDuration = wheelDuration;
		},
		setWheelSpinMode: (state, action) => {
			const wheelSpinMode = action.payload;
			state.wheelSpinMode = wheelSpinMode;
		},
		setSupergameEnabled: (state, action) => {
			const supergameEnabled = action.payload;
			state.supergameEnabled = supergameEnabled;
		},
		setSupergameCostThreshold: (state, action) => {
			const supergameCostThreshold = action.payload;
			state.supergameCostThreshold = supergameCostThreshold;
		},
		setWheelTheme: (state, action) => {
			const wheelTheme = action.payload;
			state.wheelTheme = wheelTheme;
		},
		setShowChances: (state, action) => {
			const showChances = action.payload;
			state.showChances = showChances;
		},
		setWheelSize: (state, action) => {
			const wheelSize = action.payload;
			state.wheelSize = wheelSize;
		},
		setWheelSoundVolume: (state, action) => {
			const wheelSoundVolume = action.payload;
			state.wheelSoundVolume = wheelSoundVolume;
		},
		setEmote: (state, action) => {
			const emote = action.payload;
			state.emote = emote;
		},
		setSupergameStarted: (state, action) => {
			const supergameStarted = action.payload;
			state.supergameStarted = supergameStarted;
		},
		setSupergameFinished: (state, action) => {
			const supergameFinished = action.payload;
			state.supergameFinished = supergameFinished;
		},
		setRandomSpinDuration: (state, action) => {
			state.randomSpinDuration = action.payload;
		},
		setWheelDurationMin: (state, action) => {
			state.wheelDurationMin = action.payload;
		},
		setWheelDurationMax: (state, action) => {
			state.wheelDurationMax = action.payload;
		},
		setAutoSpin: (state, action) => {
			state.autoSpin = action.payload;
		}
	},
});

export const {
	setSpinStarted,
	setWheelDuration,
	setWheelSpinMode,
	setSupergameEnabled,
	setSupergameCostThreshold,
	setWheelTheme,
	setShowChances,
	setWheelSize,
	setWheelSoundVolume,
	setEmote,
	setSupergameStarted,
	setSupergameFinished,
	setRandomSpinDuration,
	setWheelDurationMin,
	setWheelDurationMax,
	setAutoSpin
} = wheelSettingsSlice.actions;

export default wheelSettingsSlice.reducer;
